import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Transition, Combobox } from '@headlessui/react';
AtoSelectInput.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  inputClasses: PropTypes.string,
};
function AtoSelectInput({ data, inputClasses }) {
  const [selected, setSelected] = useState(data[0]);
  const [query, setQuery] = useState('');

  const filteredData =
    query === ''
      ? data
      : data.filter((d) =>
          d.name
            .toLowerCase()
            .replace(/\s+/g, '')
            .includes(query.toLowerCase().replace(/\s+/g, ''))
        );
  return (
    <div className="w-full">
      <Combobox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <div className="relative w-full">
            <Combobox.Input
              className={` outline-none ${inputClasses}`}
              displayValue={(data) => data.name}
              onChange={(event) => setQuery(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-1">
              <svg
                viewBox="0 0 20 13"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                className="h-3.5 w-3.5 text-gray-400">
                <path d="M2.35 0L10 7.63333L17.65 0L20 2.35L10 12.35L0 2.35L2.35 0Z" />
              </svg>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}>
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 ring-ato-title ring-opacity-5 focus:outline-none sm:text-sm">
              {filteredData.length === 0 && query !== '' ? (
                <div className="relative cursor-default select-none py-2 px-4 text-ato-form-text">
                  Nothing found.
                </div>
              ) : (
                filteredData.map((dt) => (
                  <Combobox.Option
                    key={dt.id}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? 'bg-red-500 text-white' : 'text-ato-form-text'
                      }`
                    }
                    value={dt}>
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? 'font-medium' : 'font-normal'
                          }`}>
                          {dt.name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? 'text-white' : 'text-red-400'
                            }`}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                              className="h-5 w-5">
                              <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"></path>
                            </svg>
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}

export default AtoSelectInput;
